import gql from 'graphql-tag'

export const fetchContactsCategoriesSelect = () => {
	return {
		query: gql`
			{
				categories: contacts_categories(
					where: { active: { _eq: true } }
					order_by: { category_name: asc }
				) {
					id
					category_name
				}
			}
		`
	}
}
